// Error tracking (§21). Unset means off, which is what dev and CI want. Two
// things keep it off the critical path: the client is a dynamic import, loaded
// only where a DSN exists, and it is asked for on the STAFF surface alone — a
// visitor's page is one short read, the staff app is where a JS error strands
// somebody mid-shift. The DSN is public by design; it only accepts events.
import type { Surface } from '@/lib/hosts';

export type SentrySetup = {
  readonly dsn: string;
  readonly environment: string;
  readonly release: string;
};

export function sentrySetup(env: ImportMetaEnv, surface: Surface): SentrySetup | null {
  const dsn = (env.VITE_SENTRY_DSN as string | undefined) ?? '';
  if (dsn === '' || surface !== 'staff') return null;
  return {
    dsn,
    environment: (env.VITE_SENTRY_ENVIRONMENT as string | undefined) ?? env.MODE,
    release: (env.VITE_APP_VERSION as string | undefined) ?? '0.0.0',
  };
}

// Split out of the main bundle: the import only happens where it is configured.
export async function startSentry(setup: SentrySetup | null): Promise<boolean> {
  if (setup === null) return false;
  // Named, not a namespace: importing * defeats tree-shaking and drags session
  // replay and the feedback widget into the chunk — 143 kB gzipped of neither.
  const { init } = await import('@sentry/browser');
  init({ ...setup, sendDefaultPii: false });
  return true;
}
